import { createContext } from "react";

export const UserContext = createContext<{
  userData: {
    userId: string;
    roles: string[];
  };
  setUserData: (userId: string, roles: string[]) => void;
}>({
  userData: {
    userId: "",
    roles: [],
  },
  setUserData: () => {
    // Standardwert ohne Provider — wird in der Anwendung nie aufgerufen.
  },
});
